//
// Gearman Job Polling Functions
//

function jobStatus(jobHandle) {
	return $.ajax({
		type: 'POST',
		url: '/gearman-job-status',
		data: {
			jobHandle: jobHandle
		}
	});
}

/**
 * Poll for the status of a background job and call the `update` callback with
 * the results.
 * @param  {String} jobID - The background job handle.
 * @param  {Function} update - An ajax success callback.
 * @param  {Number} interval - Number of miliseconds. Given to setInterval.
 * @return {Number} An interval id which can be used to cancel the interval.
 */
function pollJobStatus(jobID, update, interval) {
	var intervalID,
		interval = interval || 1000;

	var clearInterval = function (results) {
		var status = results.status;

		if (status === null || status.state === 'FINISHED' || status.state === 'ERROR') {
			window.clearInterval(intervalID);
		}
	};

	var error = function() {
		console.error('an error has occurred');
		window.clearInterval(intervalID);
	};

	var statusUpdate = function () {
		jobStatus(jobID)
			.done(update)
			.done(clearInterval)
			.fail(error);
	};

	intervalID = setInterval(statusUpdate, interval);
	return intervalID;
}

/**
 * Provide polling status for background gearman jobs
 * @param  {String} taskId -- the job handle provided by gearman from the background task
 * @param  {String} selector -- the id or class to mask and provide polling updates
 * @param  {String} taskName -- the name of the task to be printed in the mask messages
 * @param  {Function} success -- the success callback to be executed on completion
 * @param  {Function} error -- the error callback to be executed on error
 */
function getBackgroundJobStatus(taskId, selector, taskName, success, error) {

	var updateCallback = function(results) {
		var status = results.status;
		var datetime = getCurrentDate();

		// task is queued
		if (status.state === 'QUEUED') {
			msg = taskName + ' is waiting to begin. (last checked ' + datetime + ')';
			objDom.addCustomMask(selector, msg);

		// task is running
		} else if(status.state === 'RUNNING') {
			msg = taskName + ' is in progress. (last checked ' + datetime + ')';
			objDom.addCustomMask(selector, msg);

		// task is finished
		} else if (status.state === 'FINISHED') {
			objDom.removeMask(selector);
			meta = {}

			if (_.has(status, 'meta')) {
				meta = status.meta;
			}

			success && success(meta);

		// error was encountered while running task
		} else if (status.state === 'ERROR') {
			objDom.removeMask(selector);
			error && error(results);
		}
	};

	pollJobStatus(taskId, updateCallback);

};
